// extracted by mini-css-extract-plugin
export default {"container":"AlarmPage_container__Q5+Ur","body":"AlarmPage_body__ubUMs"};